import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import PageLayout from "@/components/layout/PageLayout";
import { CustomerForm } from "@/components/customers/forms/CustomerForm";

const CreateCustomerPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout maxWidth="lg" padding="md">
      <div className="space-y-6">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link to="/customers">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back to Customers
            </Link>
          </Button>
        </div>

        <div>
          <h1 className="text-2xl font-bold font-montserrat">Add New Customer</h1>
          <p className="text-sm text-muted-foreground">
            Create a new customer record with their contact and address details
          </p>
        </div>

        <CustomerForm
          layoutVariant="page"
          customer={null}
          onSave={() => navigate("/customers")}
          onCancel={() => navigate("/customers")}
        />
      </div>
    </PageLayout>
  );
};

export default CreateCustomerPage;
